/*
 * gsc-taproom-calendar.js
 *
 * Styles the eventscalendar.co embed, which renders inside a closed-off Shadow
 * DOM — page stylesheets cannot reach it, so the rules have to be appended to
 * each host's shadowRoot directly.
 *
 * Supersedes the inline block at the bottom of gsc.js, which hardcoded a single
 * project ID, ran with no null check on every page in the site, and raced the
 * embed script: the shadowRoot does not exist at the moment the deferred script
 * runs, so styling landed only when the timing happened to favour it.
 */
(function () {
  var CALENDAR_STYLES = [
    '.cl-view-agenda__event { border: 1px solid; background: #fff; padding: 20px; }',
    '.cl-view-agenda__content__inner { display: grid; grid-template-columns: repeat(4, 25%); }',
    '.cl-calendar-view.cl-view-cards, .cl-view-agenda { background: transparent !important; }',
    '.cl-component { border: none !important; }',
    '.cl-image__inner { padding-bottom: 100% !important; }',
    '.cl-view-cards__content__empty { color: white; text-align: center; font-size: 30px; margin: 90px 0; }'
  ].join('\n');

  var POLL_MS = 250;
  var MAX_ATTEMPTS = 40; // ~10s, then give up rather than spin forever

  function styleHost(host) {
    if (host.dataset.gscCalendarStyled === 'true') return true;
    if (!host.shadowRoot) return false;

    var style = document.createElement('style');
    style.textContent = CALENDAR_STYLES;
    host.shadowRoot.appendChild(style);
    host.dataset.gscCalendarStyled = 'true';
    return true;
  }

  // Returns the number of hosts still waiting for their shadowRoot.
  function sweep() {
    var pending = 0;
    document.querySelectorAll('[data-events-calendar-app]').forEach(function (host) {
      if (!styleHost(host)) pending += 1;
    });
    return pending;
  }

  var attempts = 0;
  (function poll() {
    if (sweep() === 0 || (attempts += 1) >= MAX_ATTEMPTS) return;
    window.setTimeout(poll, POLL_MS);
  })();
})();
